var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio',{attrs:{"value":_vm.value,"color":"var(--theme-color-one)","on-icon":"radio_button_checked","off-icon":"radio_button_unchecked"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }